import api from "./api";

const SESSION_KEY = "papercut_session_id";

function ensureSessionId() {
  let sid = localStorage.getItem(SESSION_KEY);
  if (!sid) {
    sid = (crypto?.randomUUID?.() || Math.random().toString(36).slice(2) + Date.now().toString(36));
    localStorage.setItem(SESSION_KEY, sid);
  }
  return sid;
}

export function getSessionId() {
  return ensureSessionId();
}

export async function trackPageview(path) {
  const session_id = ensureSessionId();
  try {
    await api.post("/analytics/track", {
      path,
      referrer: document.referrer || null,
      session_id,
    });
  } catch (e) {
    /* silent — analytics must never break UX */
  }
}

export async function sendHeartbeat(path) {
  const session_id = ensureSessionId();
  try {
    await api.post("/analytics/heartbeat", { session_id, path });
  } catch (e) {
    /* silent */
  }
}
